import { Image } from '@starsoft/common/components';
import { Decimal } from '@starsoft/common/services/Decimal';
import { GameReportBoardBet } from '../props';
import styles from './styles.module.scss';

export default function DiceGameReportBoard({ bet }: GameReportBoardBet) {
  const payout = bet?.payout;
  const won = payout?.toNumber() > 0 ? true : false;
  return (
    <div className={styles.container}>
      <div
        className={`${styles['container__multiplier']} ${won ? styles['container__multiplier--won'] : ''}`}
      >
        {`${Decimal.fromSubunits(bet?.multiplier, {
          scale: 4,
        }).toNumberString()}`}
        x
      </div>
      <Image
        width={80}
        height={80}
        src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/dice/dice.svg`}
        alt="dice-image"
      />
    </div>
  );
}
